import { Component, OnDestroy } from '@angular/core';
import { LanguageService } from 'src/app/services';
import { Subscription } from 'rxjs';
import { NgIf } from '@angular/common';


@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss'],
    standalone: true,
    imports: [NgIf]
})
export class PrivacyComponent implements OnDestroy {
    isEnglish: boolean;
    subscription: Subscription;

  constructor(
    private languageService : LanguageService,
    ) { 
    this.isEnglish = this.languageService.get() === "fr-FR" ? false : true;
    this.subscription = this.languageService.langEmitter.subscribe(el => this.isEnglish = el == "fr-FR" ? false : true);
  }

  ngOnDestroy(): void {
      this.subscription.unsubscribe();
  }
}
